import angularModule from '../front_royal_module';

angularModule.controller('ParamsPassthroughCtrl', [
    '$scope',
    '$route',
    '$routeParams',
    // eslint-disable-next-line func-names
    function ($scope, $route, $routeParams) {
        // Both the angular and react wrapper elements are always on the screen, but most of the time one
        // of them is empty. In some cases (but myseteriously not all), we've seen the angular element
        // block clicks on the react element and vice versa, so we use this scope property to disable
        // pointer events on the appropriate wrapper element depending on which element is responsible
        // for showing the UI. See the `studentDashboardV1` directive for an example.
        Object.defineProperty($scope, 'reactHandlingRoute', {
            get() {
                return $route?.current?.$$route?.routeHandledBy === 'react';
            },
        });

        $scope.directive = $route.current.directive;
        if (!$scope.directive) {
            throw new Error('No directive defined in route.');
        }

        // generate static html for compile
        let tag = `<${$scope.directive} `;
        angular.forEach($routeParams, (val, key) => {
            tag = `${tag + key}="${val}"`;
        });
        tag += ' />';
        $scope.html = tag;
    },
]);
